var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#8C959D",
    stroke: "#8C959D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5784 7.57318H3C2.72386 7.57318 2.5 7.79703 2.5 8.07318V9.00421C2.5 9.28035 2.72386 9.50421 3 9.50421H9C9.27614 9.50421 9.5 9.28035 9.5 9.00421V3.00421C9.5 2.72807 9.27614 2.50421 9 2.50421H8.0784C7.80226 2.50421 7.5784 2.72807 7.5784 3.00421V7.57318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.1a67ca2f9c989a50d40bdb799c10ed9a.svg";
export { ForwardRef as ReactComponent };